var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distance",class:{ 'visible': _vm.toggleDistance, 'invisible': !_vm.toggleDistance }},[(_vm.val)?_c('div',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.val.km)+" km")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }